'use client';

import { useEffect } from 'react';

import { useReadFullPath } from '@workspace/lib/hooks/analytics/use-read-full-path';
import {
  SESSION_STORE_KEYS,
  useSessionStore,
} from '@workspace/lib/hooks/store/use-session-store';

export function usePathTracker() {
  const { saveToSessionStore, getFromSessionStore } = useSessionStore();

  const currentFullPath = useReadFullPath();
  const prevPath = getFromSessionStore(SESSION_STORE_KEYS.previousPath);

  useEffect(() => {
    if (prevPath !== currentFullPath) {
      saveToSessionStore(SESSION_STORE_KEYS.previousPath, currentFullPath);
    }
  }, [currentFullPath, prevPath, saveToSessionStore]);
}
